import { useBuilderShowIf } from "../composables/builderFieldUtility";
import availableFilters from "@/helpers/enums/available_values.json";
const { hasValueEqualTo } = useBuilderShowIf();
import { route } from "ziggy-js";
import { Ziggy } from "@/ziggy";
export interface Alias {
    value: string;
    params?: string[];
}
export interface UrlData {
    alias: string;
    name: string;
    params: object
}

type CtaType = "button" | "link";
type CtaStyle = "primary" | "primary dark" | "secondary" | "secondary dark";
type CtaSize = "default" | "small"; // buttons only
export interface Cta {
    type: CtaType;
    label: string;
    url: {
        urlType: "general" | "product" | "external";
        generalUrl?: {
            data: UrlData,
            value: {
                data: UrlData
            }
        };
        productUrl?: {
            productType: "item" | "category" | "collection"; 
            seoName: string;
            shopAll: boolean;
        };
        externalUrl?: string;
    };
    style?: CtaStyle;
    size?: CtaSize;
    alias?: Alias;
    aria_label?: string;
    onClick?: () => void;
}

export function getCtaLink(cta: Cta): { href: string, external: boolean } | { href: string; target: string, external: boolean} | { onClick: () => void } {
    if(cta.url?.urlType == null){
        return {
            onClick: ()=>{
                alert("No URL set for this CTA");
            }
        }
    }
    if (cta.url.urlType === "general") {
        let url = cta.url.generalUrl?.value?.data ?? cta.url.generalUrl?.data;
        if (url?.alias) {
            url = route(url.alias, url.params, undefined, Ziggy);
            return {
                href: url
            }
        }
        return {
            href: "/404",
            onClick: ()=>{
                alert("No URL set for this CTA");
            }
        }
    } else if (cta.url.urlType === "product") {
        let url = route('404', undefined, undefined, Ziggy);
        if(cta.url?.productUrl?.seoName == null){
            return {
                href: url,
                external: false
            }
        }
        if(cta.url?.productUrl?.productType === "item") {
            url = route("productDetail.show", { seo_name: cta.url?.productUrl?.seoName }, undefined, Ziggy);
            
        }else if(cta?.url?.productUrl?.productType === "category") {
            url = route(`category.${cta.url.productUrl?.shopAll ? 'shop-all' : 'show'}`, { seo_name: cta.url?.productUrl?.seoName }, undefined, Ziggy);
        }else if(cta?.url?.productUrl?.productType === "collection" && cta.url?.productUrl?.seoName) {
            url = route("productListing.collection", { collection: cta.url?.productUrl?.seoName }, undefined, Ziggy);
        }
        return {
            href: url,
            external: false,
        }
    } else {
        return {
            href: cta.url.externalUrl ?? "/404",
            target: "_blank",
            external: true
        }
    }
}

export const builderCta = {
    defaultValue: { type: "button", style: "primary" },
    subFields: [
        {
            name: "type",
            type: "string",
            enum: ["button", "link"],
            required: true
        },
        {
            name: "label",
            type: "string"
        },
        {
            name: "url",
            type: "object",
            subFields: [
                {
                    name: "urlType",
                    type: "string",
                    enum: ["general", "product", "external"],
                    defaultValue: "general"
                },
                {
                    name: "generalUrl",
                    type: "reference",
                    model: "urls",
                    showIf: hasValueEqualTo("urlType","general")
                },
                {
                    name: "productUrl",
                    type: "object",
                    subFields: [
                        {
                            name: "productType",
                            type: "string",
                            enum: ["item", "category", "collection"]
                        },
                        {
                            name: "seoName",
                            type: "string",
                        },
                        {
                            name: "shopAll",
                            type: "boolean",
                        }
                    ],
                    showIf: hasValueEqualTo("urlType", "product")
                },
                {
                    name: "externalUrl",
                    type: "url",
                    showIf: hasValueEqualTo("urlType", "external")
                }
            ]
        },
        {
            name: "style",
            type: "string",
            enum: ["primary", "primary dark", "secondary", "secondary dark"],
            defaultValue: "primary"
        },
        {
            name: "size",
            type: "string",
            enum: ["default", "small"],
            defaultValue: "default",
            showIf: hasValueEqualTo("type", "button")
        },
        {
            name: "aria_label",
            type: "string"
        }
    ]
};


export function strippedCta(fields: string[]){
    let ctaFields = builderCta.subFields;
    ctaFields = ctaFields.filter((ctaField) => fields.includes(ctaField.name));

    return {
        ...builderCta,
        subFields: ctaFields
    }
}